import { useCallback, useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Icon, Text, useTranslation } from '@weareconceptstudio/core';

//* Translations
import languagesModules from '@/translations/index';

//* Styles
import LanguageSwitcherStyle from './style';

const LanguageSwitcher = ({ className = '' }) => {
	const pathname = usePathname();
	const { selectedLang } = useTranslation();

	const contRef = useRef(null);
	const oldScrollVal = useRef(0);
	const [opened, setOpened] = useState(false);

	const langArr = Object.keys(languagesModules);

	//! Handle outside clicks
	const handleWindowClick = useCallback((e) => {
		if (contRef.current && !contRef.current.contains(e.target)) {
			setOpened(false);
		}
	}, []);

	//! Close dropdown on scroll down
	const onScroll = useCallback(() => {
		if (typeof window !== 'undefined') {
			const currentScroll = window.scrollY;
			if (currentScroll > oldScrollVal.current && currentScroll > 0) {
				setOpened(false);
			}
			oldScrollVal.current = currentScroll;
		}
	}, []);

	//! Add click event listener
	useEffect(() => {
		window.addEventListener('click', handleWindowClick);
		return () => {
			window.removeEventListener('click', handleWindowClick);
		};
	}, [handleWindowClick]);

	//! Add scroll event listener
	useEffect(() => {
		window.addEventListener('scroll', onScroll);
		return () => {
			window.removeEventListener('scroll', onScroll);
		};
	}, [onScroll]);

	//! Get route without current lang
	const route = pathname.replace(`/${selectedLang}`, '');

	return (
		<LanguageSwitcherStyle className={`languages-switcher-wrapper ${className} ${opened ? 'opened' : ''}`}>
			<div
				ref={contRef}
				onClick={() => setOpened((prev) => !prev)}
				className='selected-lang-wrap'
			>
				<Text
					text={selectedLang}
					className='p1 light-gray-1000 font-fss-regular selected-lang'
				/>
				<Icon
					name='dropdown-arr'
					className='p1 light-gray-1000 selected-lang-icon'
				/>
			</div>

			<div className='languages-wrapper'>
				<div className='languages-inner-wrapper'>
					{langArr.map(
						(lang) =>
							lang !== selectedLang && (
								<div
									key={lang}
									className='lang-item-block'
								>
									<Link
										href={`/${lang}${route}`}
										className='lang-item-link'
									>
										<Text
											className='p1 light-gray-1000 font-fss-regular lang-item'
											text={lang}
										/>
									</Link>
								</div>
							)
					)}
				</div>
			</div>
		</LanguageSwitcherStyle>
	);
};

export default LanguageSwitcher;
